export default __webpack_public_path__ + "static/media/BrainBreak cards50.ead0b5b6.png";